import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class BackService {
  constructor(readonly location: Location, readonly router: Router) {}

  goBack(url?: string) {
    const locationState = this.location.getState() as any;
    if (locationState?.navigationId && locationState.navigationId > 1) {
      this.location.back();
    } else {
      this.router.navigateByUrl(url || '/');
    }
  }
}
